<template>
  <div>
    <Topbar />
    <div id="content">
        <div class="container">
            <div class="login_wrapper col-12 col-md-6 offset-md-3 br bs bg-white p-4 text-center">
                <h1>401</h1>
                <h1 class="pt-3 pb-5 mb-5">Unauthorized Access</h1>
                <button class="btn btn-primary" @click="goHome">Go Home</button>
            </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Topbar from '../components/Topbar.vue'
import Footer from '../components/Footer.vue'

export default {
  components: {
    Topbar,
    Footer,
  },
  methods: {
    goHome() {
        if (typeof localStorage.getItem('dataUser') !== 'undefined' && localStorage.getItem('dataUser') !== null) {
            this.$router.push({name: 'home'});
        } else {
            this.$router.push({name: 'login'});
        }
    }
  },
};
</script>